import { FC, ReactNode, useRef } from 'react'
import { useInView } from 'framer-motion'
import styled from 'styled-components/macro'

const Container = styled.div`
  transition: 1.4s opacity;

  &:not([data-visible='true']) {
    opacity: 0;
  }
`

export const ScrollOpacity: FC<{ children: ReactNode }> = ({ children }) => {
  const ref = useRef(null)
  const isInView = useInView(ref, { amount: 'all', once: true })

  return (
    <Container data-visible={isInView} ref={ref}>
      {children}
    </Container>
  )
}
